import React, { ReactElement } from 'react';
import { Strip } from '../../Models/Article';
import { DiscoverItem } from '../../Models/DiscoverItem';
import { Link } from '../../Devon/Components/InkyLink';
import KodanshaWheelItem from '../KodanshaWheel/KodanshaWheelItem';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import KodanshaSlider from './KodanshaSlider';
import './WheelStrip.scss';

interface WheelStripProps {
    strip: Strip;
}

interface Params {
    title: string;
    subTitle: string;
    callToActionText?: string;
    callToActionUrl?: string;
    items: DiscoverItem[];
}

export function WheelStrip({ strip: { params } }: WheelStripProps): ReactElement {
    const { title, subTitle, callToActionText, callToActionUrl, items } = params as Params;
    const hasProductItems = items.some(item => item.type === 'product');
    const hasSeriesItems = items.some(item => item.type === 'series');
    const isMixed = hasProductItems && hasSeriesItems;
    const ratio = isMixed ? 125 : undefined;
    return (
        <div className='WheelStrip'>
            <KodanshaSlider title={title} subtitle={subTitle}>
                {items.slice(0, 20).map(item => (
                    <KodanshaWheelItem
                        key={item.content?.id}
                        product={item}
                        cta={item.cta}
                        title={item.content?.title ?? ''}
                        ratio={ratio}
                    />
                ))}
            </KodanshaSlider>
            {!!callToActionText && !!callToActionUrl && (
                <Link to={callToActionUrl}>
                    <KodanshaArrow text={callToActionText} withArrow={true} />
                </Link>
            )}
        </div>
    );
}
